import { type ReactNode } from "react";

import useCurrentUser from "~/lib/organizations/hooks/use-current-user";

import { useSubscriptionWrapper } from "../hooks/useSubscriptionWrapper";

const SubscriptionWrapper = ({ children }: { children: ReactNode }) => {
  useSubscriptionWrapper();

  const currentUser = useCurrentUser();

  if (!currentUser) return null;

  return <>{children}</>;
};

export default SubscriptionWrapper;
